import React from "react";
import { createRoot } from "react-dom/client";
import {
    initialiseSentry,
    captureManualException,
} from "supercell-frontend-base/src/tracing/sentry";

import { App } from "./components/app";
import { deepLinkSchema } from "inbox-contentful";

const protocol = deepLinkSchema.clashofclans;

const sendCommand =
    window["sendCommand"] ??
    ((command: string) => {
        console.log("sendCommand", command);
        window.location.href = command;
    });

window.setParams = () => {
    // Empty function here since sometimes the game calls setParams too early
};

window.sendCommand =
    window.sendCommand ||
    ((command: string) => {
        sendCommand(`${protocol}://${command}`);
    });

if (window.SENTRY_DSN) {
    initialiseSentry(
        {
            dsn: window.SENTRY_DSN,
        },
        window.BUILD_INFO,
    );
}

if (window.BUILD_INFO) {
    console.log("Build", window.BUILD_INFO);
    console.log("Viewport size", {
        width: window.innerWidth,
        height: window.innerHeight,
    });
}

let root: ReturnType<typeof createRoot> | null = null;

const render = () => {
    const rootElement = document.getElementById("inbox");

    if (rootElement === null) {
        const msg = "Failed to render Inbox, could not find root element";
        console.error(msg);
        captureManualException(new Error(msg));
        return;
    }

    if (!root) {
        root = createRoot(rootElement);
    }

    root.render(<App sendCommand={sendCommand} />);
};

window.history.replaceState({ root: true }, undefined);
window.history.pushState({ home: true }, undefined);
window.onpopstate = ({ state }) => {
    if (state && state.root) window.history.forward();
};

window.addEventListener("load", () => {
    render();
});
